<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row mt">
                <div class="col col-md-6">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="realEstatePropertyType"
                    direction="column"
                    [isDefault]="false"
                    columns="4"
                    [options]="realEstatePropertyTypeOptions"
                    label="Type de résidence"
                  >
                  </pr-input-radio>
                </div>
                <div class="col col-md-6">
                  <pr-input-column label="Surface" [derrors]="derrors">
                    <input
                      formControlName="realEstateSurface"
                      type="number"
                      fraction="2"
                    />
                    <i>m²</i>
                  </pr-input-column>
                </div>
                <!-- <div class="col col-md-6">
                <pr-input-date formControlName="purchaseDate" label="Date d'achat" [derrors]="derrors"
                    [isDefault]="false" [hidden]="
                      product?.get('parameters')?.get('includeCGA')?.value ==
                      false
                    ">
                </pr-input-date>
              </div> -->
              </div>
              <div class="row">
                @if (countries$ | async; as countries) {
                  <div class="col col-md-12">
                    <pr-input-maps
                      label="Adresse"
                      formGroupName="realEstateAddress"
                      [isGMaps]="true"
                      [countries]="countries"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                    </pr-input-maps>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
